/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../adpIntegration/adpIntegration.context.ts" />

module Meevo.Plugins.AdpWfnIntegration {
    "use strict";
    
    export class AdpWfnIntegrationContext extends Meevo.Plugins.AdpIntegration.AdpIntegrationContext {
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            busyService: Meevo.Components.Busy.IBusyService,
            $rootScope: ng.IRootScopeService,
            protected $translate: angular.translate.ITranslateService,
            contextParams: Meevo.ContextParamsService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService,
                busyService,
                $rootScope,
                $translate,
                contextParams);

        }

        Init(): void {
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.adpWfnIntegration;
            this.sectionTemplatePath = "app/plugins/adpWfnIntegration/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.INTEGRATION_ADPWFNINTEGRATION_TAB_MAIN);
        }
     
        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_ADPWFNINTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.mainSection = new WfnMainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "?CreateNewConnectorId=false",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.AdpWfnIntegrtionMain,
                    this.identityService,
                    this.modalService,
                    this.busyService,
                    this.securityKeys.INTEGRATION_ADPWFNINTEGRATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                this.sections.push(this.mainSection);
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_ADPWFNINTEGRATION_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.employeeSection = 
                    new WfnEmployeeSection(1,
                        "HEADER_EMPLOYEE",
                        "employee.html",
                        false,
                        false,
                        this.baseEndpoint,
                        "mapemployees",
                        this.loggingService,
                        this.dataService,
                    Model.NounEnum.AdpWfnIntegrtionEmployee,
                        this.identityService,
                        this.modalService,
                        this.busyService,
                        this.rootScope,
                        this.appSettings,
                        this.securityKeys.INTEGRATION_ADPWFNINTEGRATION_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                this.sections.push(this.employeeSection);
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_ADPWFNINTEGRATION_TAB_COMMISSION + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.commissionSection = new WfnCommissionSection(2,
                    "LABEL_PAY_OPTIONS",
                    "commission.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "mapcommissiontypes",
                    this.loggingService,
                    this.dataService,
                    this.$translate,
                    Model.NounEnum.AdpWfnIntegrtionCommission,
                    this.identityService,
                    this.modalService,
                    this.busyService,
                    this.compensationSettingsEndPoint,
                    this.securityKeys.INTEGRATION_ADPWFNINTEGRATION_TAB_COMMISSION + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
                this.sections.push(this.commissionSection);
            }
           
            this.activate();
          
        }

        getNewConnectorId(): void {
            this.busyService.start();
            this.dataService.getSection(this.baseEndpoint, "?CreateNewConnectorId=true").then((data: any) => {
                this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                super.refresh();
            }).finally(() => { this.busyService.stop(); });
        }
        verifyConnectorId(connectorId: string): void {
            if (!_.isUndefined(connectorId) && connectorId.length == 36)
                this.dataService.getSection(this.baseEndpoint, connectorId + "/VerifyToLink").then((data: any) => {
                    if (_.isUndefined(data.connectorStatus) || data.connectorStatus.toUpperCase() != "ACTIVE")
                        this.modalService.info("MESSAGE_ADP_CONNECTOR_NOTACTIVE");
                    else {
                        this.dataService.getSection(this.baseEndpoint, connectorId + "/Locations").then((locations: any) => {
                            let message = '';

                            if (locations.length > 0) {
                                message = `${connectorId} is currently linked with the following locations, <div><ul>`;

                                for (let l of locations) {
                                    let str = `<li>${l.storeName} (${l.adpCompanyCode}) </li>`
                                    message += str;
                                }
                                message += "</ul></div>"
                            }
                            else
                                message = `${connectorId} is not linked with any location,`

                            message += 'Continue to link with your location?'

                            this.modalService.confirmHandler(message, Meevo.Components.Modal.ModalTranslationModes.AsHtml).then((d: any) => {
                                if (d) {
                                    this.dataService.update(this.baseEndpoint, null, connectorId + "/LinkLocation").then((data: any) => {
                                        if (data) {
                                            this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                                            super.refresh();
                                        }
                                    })
                                }
                            })
                        });
                    }
            })
        }

        hasAdpCompanyCodeAndEnabled(): boolean {
            return Model.Guard.isSomething(this.selectedSection.model.adpIntegrationInfo) &&
                Model.Guard.isSomething(this.selectedSection.model.adpIntegrationInfo.adpCompanyCode) &&
                this.selectedSection.model.adpIntegrationInfo.adpCompanyCode.length > 0 &&
                this.selectedSection.model.adpIntegrationInfo.adpIntegrationStatus;
        }

        public goToMarketplace(): void {
            const marketplaceLink = window['AdpWfnLinkMarketplace'];
            window.open(marketplaceLink, '_blank');
        }

        public goToConsent(): void {
            const consentLink = window['AdpWfnLinkConsent'];
            window.open(consentLink, '_blank');
        }

        public goToAdpLogin(): void {
            const adpWfnLoginLink = window['AdpWfnLoginLink'];
            window.open(adpWfnLoginLink, '_blank');
        }
    }
}
